import { useMemo, useState } from 'react';
import { OnboardingContext } from './OnboardingContext';

export const OnboardingProvider = ({ children }) => {
  const [showOnboardingProcess, setShowOnboardingProcess] = useState<boolean>(false);
  const [finishedOnboarding, setFinishedOnboarding] = useState<boolean>(false);
  const value = useMemo(
    () => ({ showOnboardingProcess, setShowOnboardingProcess, finishedOnboarding, setFinishedOnboarding }),
    [showOnboardingProcess, finishedOnboarding]
  );
  return <OnboardingContext.Provider value={value}>{children}</OnboardingContext.Provider>;
};
